import { render } from "./consultarFoliosQrs.vue?vue&type=template&id=367cc9b6"
import script from "./consultarFoliosQrs.vue?vue&type=script&lang=js"
export * from "./consultarFoliosQrs.vue?vue&type=script&lang=js"

import "./consultarFoliosQrs.vue?vue&type=style&index=0&id=367cc9b6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__